module.exports = __webpack_public_path__ + "img/ronline.cf731112.svg";